import { Fragment, useState } from "react";
import { FiChevronDown } from "react-icons/fi";
import { formatNaira } from "../../utils/dashboardFormat";
import { normalizePaymentRow, whenLabel } from "./contribModel";
import { Person, Pill } from "./parts";

/**
 * Payments as a table whose rows open to show everything about one payment.
 * Used on the category page and on All payments.
 */
export default function PaymentsTable({ rows = [], showCategory = true, showMember = true }) {
  const [open, setOpen] = useState(null);
  const items = rows.map(normalizePaymentRow);
  const columns = 4 + (showMember ? 1 : 0) + (showCategory ? 1 : 0) + 1;

  return (
    <div className="cb-scroll">
      <table className="cb-table">
        <thead>
          <tr>
            <th>Date</th>
            {showMember ? <th>Member</th> : null}
            {showCategory ? <th>Category</th> : null}
            <th className="num">Amount</th>
            <th>Method</th>
            <th>Status</th>
            <th aria-label="Details" />
          </tr>
        </thead>
        <tbody>
          {items.map((p, i) => {
            const key = p.id ?? i;
            const isOpen = open === key;
            return (
              <Fragment key={key}>
                <tr>
                  <td>
                    {whenLabel(p.date) || "—"}
                    {p.createdAt && whenLabel(p.createdAt, true) ? <span className="cb-sub">{whenLabel(p.createdAt, true).split(", ")[1]}</span> : null}
                  </td>
                  {showMember ? (
                    <td>
                      <Person name={p.memberName} sub={p.memberNo ? `#${p.memberNo}` : ""} photo={p.photo} />
                    </td>
                  ) : null}
                  {showCategory ? <td>{p.categoryName || "—"}</td> : null}
                  <td className="num" style={{ fontWeight: 600, color: "var(--cb-ink)" }}>
                    {formatNaira(p.amount)}
                  </td>
                  <td style={{ textTransform: "capitalize" }}>{p.method ? p.method.toLowerCase() : "—"}</td>
                  <td>
                    <Pill tone={p.status.tone}>{p.status.label}</Pill>
                  </td>
                  <td className="num" style={{ paddingRight: 0 }}>
                    <button type="button" className="cb-btn sm" aria-expanded={isOpen} aria-label={`${isOpen ? "Hide" : "Show"} details of the payment by ${p.memberName}`} onClick={() => setOpen(isOpen ? null : key)}>
                      <FiChevronDown size={16} aria-hidden="true" style={{ transform: isOpen ? "rotate(180deg)" : "none" }} />
                    </button>
                  </td>
                </tr>
                {isOpen ? (
                  <tr>
                    <td colSpan={columns} style={{ background: "#faf8f8" }}>
                      <dl style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(190px, 1fr))", gap: "8px 24px", margin: 0 }}>
                        <div>
                          <dt className="cb-faint">Reference or code</dt>
                          <dd className="cb-ref" style={{ margin: 0 }}>{p.code || "None recorded"}</dd>
                        </div>
                        <div>
                          <dt className="cb-faint">Recorded by</dt>
                          <dd style={{ margin: 0 }}>{p.recordedBy || "The member, online"}</dd>
                        </div>
                        <div>
                          <dt className="cb-faint">Added to the system</dt>
                          <dd style={{ margin: 0 }}>{whenLabel(p.createdAt, true) || "—"}</dd>
                        </div>
                      </dl>
                    </td>
                  </tr>
                ) : null}
              </Fragment>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
